<template>
  <component
    ref="input"
    :is="componentToUse"
    :value="value"
    @input="
      val => {
        $emit('update:modelValue', val)
      }
    "
    :label="label"
    :detailText="detailText"
    :type="type"
    :required="required"
    :disabled="disabled"
    :allowTrailingZero="allowTrailingZero"
    :placeHolder="placeHolder"
    :prefix="prefix"
    :suffix="suffix"
    :alwaysShowPrefix="alwaysShowPrefix"
    :alwaysShowSuffix="alwaysShowSuffix"
    :alwaysShowPasswordEye="alwaysShowPasswordEye"
    :forceUppercase="forceUppercase"
    :trim="trim"
    :preventKeyDown="
      type == 'select' && preventKeyDown == null ? true : preventKeyDown
    "
    :min="min"
    :minLenght="minLenght"
    :max="max"
    :numberStep="numberStep"
    :validate="validate"
    :inputProperties="inputProperties"
    :formatInputToValue="formatInputToValue"
    :formatOptionsDisplay="formatOptionsDisplay"
    :formatOptionInputDisplay="formatOptionInputDisplay"
    :formatSearchQuery="formatSearchQuery"
    :formatOptionsFromData="formatOptionsFromData"
    :optionsContentId="optionsContentId"
    :options="options"
    :optionsAreSame="optionsAreSame"
    :valueMustBeInOptions="valueMustBeInOptions"
    :preventOptionSelect="preventOptionSelect"
    :autoHide="autoHide"
    :minDate="minDate"
    v-slot="data"
  >
    <slot v-if="Commons.slotHasContent($slots.default)" :data="data" />
  </component>
</template>

<script>
import { defineComponent } from 'vue'
import AutocompletInput from './AutocompletInput.vue'
import SelectInput from './SelectInput.vue'
import TextInput from './TextInput.vue'
import Commons from '@/shared/utils/commons'

export default defineComponent({
  name: 'InputComponent',
  components: {
    AutocompletInput,
    SelectInput,
    TextInput,
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    detailText: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowTrailingZero: {
      type: Boolean,
      default: false,
    },
    placeHolder: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    alwaysShowPrefix: {
      type: Boolean,
      default: false,
    },
    alwaysShowSuffix: {
      type: Boolean,
      default: false,
    },
    alwaysShowPasswordEye: {
      type: Boolean,
      default: false,
    },
    forceUppercase: {
      type: Boolean,
      default: false,
    },
    trim: {
      type: Boolean,
      default: false,
    },
    preventKeyDown: {
      type: Boolean,
      default: null,
    },
    min: {
      type: [Number, String],
      default: 0,
    },
    minLenght: {
      type: [Number, String],
      default: 0,
    },
    max: {
      type: [Number, String],
      default: '',
    },
    numberStep: {
      type: [Number, String],
      default: 1,
    },
    validate: {
      type: Function,
      default: () => {
        return ''
      },
    },
    inputProperties: {
      type: Object,
      default: () => {
        return {}
      },
    },
    options: {
      type: Array,
      default: () => {
        return []
      },
    },
    optionsAreSame: {
      type: Function,
      default: null,
    },
    formatOptionsDisplay: {
      type: Function,
      default: null,
    },
    formatInputToValue: {
      type: Function,
      default: null,
    },
    formatOptionInputDisplay: {
      type: Function,
      default: null,
    },
    valueMustBeInOptions: {
      type: Boolean,
      default: true,
    },
    formatSearchQuery: {
      type: Function,
      default: null,
    },
    formatOptionsFromData: {
      type: Function,
      default: null,
    },
    optionsContentId: {
      type: String,
      default: null,
    },
    preventOptionSelect: {
      type: Boolean,
      default: false,
    },
    autoHide: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: [Number, Date],
      default: Date.now(),
    },
  },
  emits: ['update:modelValue'],
  setup() {
    return { Commons }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    reloadInputContent() {
      this.$refs.input.reloadInputContent()
    },
    externalSetValue(...args) {
      this.$refs.input.externalSetValue(...args)
    },
  },
  computed: {
    componentToUse() {
      if (this.type == 'select') return 'SelectInput'
      if (this.type == 'autocomplet') return 'AutocompletInput'
      return 'TextInput'
    },
  },
})
</script>
